var map = {
	"./add.svg": 29218,
	"./alipay.svg": 85971,
	"./arrdown.svg": 37950,
	"./arrleft.svg": 42869,
	"./arrup.svg": 31605,
	"./article-create.svg": 81642,
	"./article-ranking.svg": 93932,
	"./article.svg": 70801,
	"./audit.svg": 5990,
	"./bankcard.svg": 58329,
	"./bankcard1.svg": 74714,
	"./base-data.svg": 86595,
	"./bell.svg": 70734,
	"./binding.svg": 6540,
	"./blocked.svg": 62215,
	"./brandshop.svg": 96984,
	"./cart-down.svg": 43364,
	"./change-theme.svg": 86005,
	"./chart.svg": 64039,
	"./close.svg": 26515,
	"./cloth.svg": 28335,
	"./cloth1.svg": 50572,
	"./colapse.svg": 5038,
	"./collapse.svg": 58328,
	"./copy.svg": 42918,
	"./dashboard.svg": 23415,
	"./data-upload.svg": 949,
	"./delete.svg": 48896,
	"./diagnosis.svg": 14868,
	"./disabled.svg": 81649,
	"./disdroy.svg": 42037,
	"./down.svg": 11213,
	"./download.svg": 86853,
	"./download2.svg": 3885,
	"./edit.svg": 95885,
	"./empty.svg": 54384,
	"./error.svg": 61225,
	"./example.svg": 96801,
	"./exit-fullscreen.svg": 97373,
	"./expand.svg": 51561,
	"./expaned.svg": 62356,
	"./eye-open.svg": 95325,
	"./eye.svg": 21788,
	"./financial.svg": 88530,
	"./fullscreen.svg": 38718,
	"./getback.svg": 20502,
	"./gouxuan.svg": 36904,
	"./group.svg": 70902,
	"./guide.svg": 18403,
	"./hamburger-closed.svg": 48199,
	"./hamburger-opened.svg": 34920,
	"./histoires.svg": 91721,
	"./image.svg": 92344,
	"./info.svg": 22789,
	"./international.svg": 76083,
	"./introduce.svg": 81576,
	"./inventory.svg": 91607,
	"./language.svg": 76463,
	"./link.svg": 54485,
	"./loading.svg": 94159,
	"./medtruansfer.svg": 21467,
	"./myreg.svg": 11947,
	"./nested.svg": 67816,
	"./new.svg": 49393,
	"./next.svg": 43830,
	"./outlinepay.svg": 70333,
	"./outorder.svg": 61621,
	"./package.svg": 67547,
	"./password.svg": 68910,
	"./permission.svg": 49636,
	"./personnel-info.svg": 59808,
	"./personnel-manage.svg": 36417,
	"./personnel.svg": 3987,
	"./prev.svg": 43786,
	"./refresh.svg": 96066,
	"./require.svg": 79114,
	"./reward.svg": 27284,
	"./role.svg": 12149,
	"./save.svg": 21466,
	"./search.svg": 6649,
	"./setting.svg": 34499,
	"./setting1.svg": 70312,
	"./shared.svg": 45910,
	"./shift.svg": 2459,
	"./size.svg": 83230,
	"./size1.svg": 36995,
	"./success.svg": 27802,
	"./table.svg": 7903,
	"./tel.svg": 72084,
	"./tree.svg": 88493,
	"./up.svg": 76274,
	"./upload.svg": 19378,
	"./user.svg": 62528,
	"./video.svg": 69658,
	"./viewer.svg": 94507,
	"./warn.svg": 31985,
	"./wechat.svg": 75135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;